import axios from 'axios';
import baseUrl from './baseUrl';
import isOffline from './isOffline';

/**
 * Updated token to a let reference
 * Removed delete and replaced with a local object assign
 * Update getUserToken error handling optional to change to stack again, but sent only message
 * Added local try as function is async
 *
 */

export default async function request(request) {
	let token = await getUserToken();

	let reqObj = Object.assign(request, {
		baseURL: baseUrl(),
		headers: { Authorization: `Bearer ${token}` }
	});

	try {
		let res = await axios(reqObj);
		return res.data;
	} catch (e) {
		if (e.message === 'Network Error') {
			// We might want to do something smart with network errors.
		}
		throw e;
	}
}

async function getUserToken() {
	if (isOffline()) return 'fakeToken';

	try {
		let userAuth = require('./userAuth').default;
		let user = await userAuth.getCurrentUser();

		if (!user) throw new Error('User not logged in');

		let userToken = await user.getIdToken();
		return userToken;
	} catch (err) {
		return new Error(err.message);
	}
}
